import FlowStepService from 'src/modules/flowStep/flowStepService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/store';

const prefix = 'FLOWSTEP_VIEW';

const flowStepViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: flowStepViewActions.FIND_STARTED,
      });

      const record = await FlowStepService.find(id);

      dispatch({
        type: flowStepViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: flowStepViewActions.FIND_ERROR,
      });

      getHistory().push('/flow-step');
    }
  },
};

export default flowStepViewActions;
